var _rect, _rect2, _circle, _circle2, _rect3, _circle3, _circle4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIngenico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 46,
    viewBox: "0 0 65.57 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 50,
    height: 33,
    rx: 2.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 51,
    height: 10,
    fill: "#7C7D7C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 38,
    r: 4,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 38,
    r: 4,
    fill: "#A3A6A3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 50,
    height: 33,
    rx: 2.5,
    stroke: "#7C7D7C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 22,
    r: 8,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 22,
    r: 4,
    fill: "#686868"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8011 12.4433C45.5148 13.2403 45.9289 14.1185 46.7259 14.4048C50.9701 15.9291 53.1829 20.6221 51.6586 24.8663C51.3724 25.6634 51.7865 26.5416 52.5835 26.8279C53.3805 27.1141 54.2588 26.7 54.545 25.903C55.5604 23.076 55.414 20.0229 54.1329 17.306C52.852 14.5891 50.5896 12.5337 47.7626 11.5184C46.9656 11.2321 46.0873 11.6462 45.8011 12.4433Z",
    fill: "#686868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8846 7.26652C46.6716 7.96605 47.0661 8.70583 47.7656 8.9188C55.2156 11.1869 59.4314 19.0932 57.1633 26.5432C56.9503 27.2427 57.3448 27.9825 58.0443 28.1954C58.7438 28.4084 59.4836 28.0139 59.6966 27.3144C60.3558 25.149 60.5712 22.9185 60.3366 20.6849C60.1101 18.5281 59.4758 16.4602 58.4512 14.5387C57.4266 12.6171 56.0631 10.9382 54.3984 9.5483C52.6744 8.10889 50.7023 7.04475 48.5369 6.38549C47.8374 6.17253 47.0976 6.56699 46.8846 7.26652Z",
    fill: "#686868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0573 1.71148C47.706 2.65679 48.1876 3.70798 49.1329 4.05927C59.2005 7.80059 64.3473 19.035 60.606 29.1025C60.2547 30.0478 60.7362 31.099 61.6816 31.4503C62.6269 31.8016 63.6781 31.32 64.0294 30.3747C65.1168 27.4485 65.5986 24.3958 65.4612 21.3014C65.3286 18.3135 64.6272 15.414 63.3763 12.6837C62.1254 9.9532 60.3878 7.52858 58.2116 5.47691C55.9578 3.35213 53.3314 1.72335 50.4051 0.635882C49.4598 0.284586 48.4086 0.766169 48.0573 1.71148Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngenico);
export default __webpack_public_path__ + "static/media/ingenico.781d7a56851fec80e02165926b3bf215.svg";
export { ForwardRef as ReactComponent };